import React, { useState } from 'react';

import styles from './metric_card.module.css';

// Shared chrome for every Program Insights metric card: title, subtitle, an optional "depends on
// client data feed" badge, and an info button that toggles a plain-language description. The metric
// body (KPIs, charts, states) is passed in as children so each slice only owns its own content.
export default function MetricCard({ title, subtitle, description, dependsOnFeed = false, children }) {
  const [descriptionOpen, setDescriptionOpen] = useState(false);

  return (
    <section className={styles.card}>
      <div className={styles.header}>
        <div className={styles.heading}>
          <div className={styles.titleRow}>
            <h2 className={styles.title}>{title}</h2>
            {dependsOnFeed && <span className={styles.feedBadge}>⚠ Depends on client data feed</span>}
          </div>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>

        {description && (
          <button
            type='button'
            aria-label={descriptionOpen ? 'Hide description' : 'Show description'}
            aria-expanded={descriptionOpen}
            className={`${styles.infoButton} ${descriptionOpen ? styles.infoButtonOpen : ''}`}
            onClick={() => setDescriptionOpen((open) => !open)}
          >
            <span className={styles.infoMark} aria-hidden='true'>
              i
            </span>
          </button>
        )}
      </div>

      {description && descriptionOpen && <p className={styles.description}>{description}</p>}

      <div className={styles.body}>{children}</div>
    </section>
  );
}
